<template>
    <div>
        <HeaderBg :img="img" title="مدن التوصيل" />
        <Alert 
            v-if="alertToggle == true"
            :acceptedDelete="acceptedDeleteCity" 
            messege="هل أنت متأكد من مسح المدينة ؟"
        />
        <header class="admin_content_header">
            <div class="filter">
                <!-- <select>
                    <option value="" selected disabled>المدينة</option>
                </select> -->
            </div>
            <div class="search">
                <!-- <input type="text" placeholder="البحث برقم الفرع"> -->
            </div>
            <router-link to="/store-admin/cities/add-city"> + إضافة مدينة </router-link>
            
        </header>
        <RequestSpinner v-if="loadingRequest == true" />
        <div class="main_table" v-if="loadingRequest == false">
            <table width="100%">
                <thead>
                    <tr>
                        <th> المدينة</th>
                        <th> سعر التوصيل لطلبات وصفتي</th>
                        <th> سعر التوصيل للطلبات</th>
                        <th></th>
                        <th></th>
                        <th></th>
                        <th></th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="city in cities" :key="city.id">
                        <td>{{city.translation[0].name}}</td>
                        <td>{{city.delivery_price}}</td>
                        <td>ريال</td>
                        <td></td>
                        <td></td>
                        
                        <td>
                            <div class="options_container">
                                <router-link :to="'/store-admin/cities/district/'+city.id" class="saveBtn">
                                    الاحياء 
                                    <b-icon icon="chevron-left" aria-hidden="true"></b-icon>
                                </router-link>
                            </div>
                        </td>

                        <td>
                            <div class="block actions">
                                <div class="delete" @click="() => deleteData(city.id)">
                                    <b-icon icon="trash" aria-hidden="true"></b-icon>
                                </div>
                                <div class="edit" @click="() => editCity(city.id)">
                                    <img src="../../../assets/images/editLogo.svg" alt="">
                                </div>
                            </div>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
        <div class="pagination mt-5" v-if="cities.length >= 1">
            <b-pagination-nav align="center" :link-gen="linkGen" :number-of-pages="pages" use-router v-model="currentPage"></b-pagination-nav>
        </div>
    </div>
</template>
<script>
import HeaderBg from '../../global/HeaderBg/HeaderBg';
import RequestSpinner from '../../global/loadingSpinners/RequestSpinner';
import store from "@/store/index.js";
import Request from '../../../services/Request';
import Alert from '../../global/Alert/Alert';

export default {
    name: 'Cities',
    components: {HeaderBg, RequestSpinner, Alert},
    data(){
        return{
            loadingRequest: true,
            img: require('../../../assets/images/locationLarg.png'),
            cities: [],

            deleteID: '',
            alertToggle: false,

             // pagination
            apiParams: '',
            currentPage: 1,
            pages: 1,
        }
    },
    mounted(){
        // get pagination page number from url
        const params = new URLSearchParams(window.location.search);
        const page = params.get('page');
        if(page){
            this.currentPage = page
        }
        this.getCities();
    },
    methods:{
        getCities(){
            Request.fetch('admin/city', this.apiParams , {
                limit: store.state.limit
            })
            .then((response) => {
                this.cities = response.data.data
                this.loadingRequest = false;
                this.pages = Math.ceil(response.data.total / store.state.limit) 
            })
            .catch(err => {
                if(Request.statusIsFaield(err)){
                    this.$router.push('/login')
                    localStorage.removeItem('token')
                }
            });
        },
        editCity(id){
            this.$router.push(`/store-admin/cities/add-city/${id}`)
        },
        deleteData(id){
            this.deleteID = id;
            this.alertToggle = true;
        },
        acceptedDeleteCity(){
            Request.delete('admin/city',this.deleteID)
            .then( () => {
                this.getCities();
            })
        },

        // pagination function
        linkGen(pageNum) {
            return pageNum === 1 ? '?' : `?page=${pageNum}`   
        },
    },
    watch: {
        // pagination
        currentPage: function(val) {
            if(val === 1){
                this.apiParams = '';
                this.getCities();
            } else{
                this.apiParams = `?page=${val}`;
                this.getCities();
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.saveBtn{
    margin-top: 0;
    display: block;
    &:hover{
        color: #FFF;
    }
}
.actions{
    display: flex;
    align-items: center;
    .delete,
    .edit{
        width: 40px;
        height: 34px;
        border-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #FF002B;
        cursor: pointer;
        svg{
            color: #FFF;
            font-size: 25px;
        }
    }
    .edit{
        background-color: #78A28F;
        margin-right: 10px;
    }
}
</style>